/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Generating_ProxyInputs */

const en_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating Proxy Stream...`)
};

const fr_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation du flux proxy...`)
};

const de_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy-Stream wird generiert...`)
};

const it_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione del flusso proxy...`)
};

const ru_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация прокси-потока...`)
};

const es_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando flujo proxy...`)
};

const zh_cn2_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成代理流...`)
};

const ja_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシ ストリームを生成しています...`)
};

const hi_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी स्ट्रीम जनरेट हो रही है...`)
};

const pt_pt2_load_project_file_status_generating_proxy = /** @type {(inputs: Load_Project_File_Status_Generating_ProxyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando fluxo proxy...`)
};

/**
* | output |
* | --- |
* | "Generating Proxy Stream..." |
*
* @param {Load_Project_File_Status_Generating_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_generating_proxy = /** @type {((inputs?: Load_Project_File_Status_Generating_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Generating_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_generating_proxy(inputs)
	if (locale === "de") return de_load_project_file_status_generating_proxy(inputs)
	if (locale === "it") return it_load_project_file_status_generating_proxy(inputs)
	if (locale === "ru") return ru_load_project_file_status_generating_proxy(inputs)
	if (locale === "es") return es_load_project_file_status_generating_proxy(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_generating_proxy(inputs)
	if (locale === "ja") return ja_load_project_file_status_generating_proxy(inputs)
	if (locale === "hi") return hi_load_project_file_status_generating_proxy(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_generating_proxy(inputs)
	return en_load_project_file_status_generating_proxy(inputs)
});